import React from 'react';

export default React.createContext({
  fetch: () => {
    throw new Error('fetch not implemented');
  },
});



// WEBPACK FOOTER //
// src/AppContext.js